import { render, staticRenderFns } from "./plan_new_q.vue?vue&type=template&id=67ff9c89"
import script from "./plan_new_q.vue?vue&type=script&lang=js"
export * from "./plan_new_q.vue?vue&type=script&lang=js"
import style0 from "./plan_new_q.vue?vue&type=style&index=0&id=67ff9c89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports